(function talendo() {
  const IFRAME_ID = 'talendo_iframe';
  const IFRAME_WIDTH = '100%';
  const IFRAME_HEIGHT = '0';

  const setAttribute = (iframe) => {
    iframe.setAttribute('frameborder', 0);
    iframe.setAttribute('scrolling', 'no');
  };

  const setSize = (iframe, { width, height } = {}) => {
    iframe.style.width = width || IFRAME_WIDTH;
    iframe.style.height = height || IFRAME_HEIGHT;
  };

  function TalendoIFrame(options) {
    this.options = { ...this.options, ...options };
    this._init();
  }

  TalendoIFrame.prototype.options = {
    id: IFRAME_ID
  };

  TalendoIFrame.prototype._init = function _init() {
    this.iframe = document.getElementById(this.options.id);
    setAttribute(this.iframe);
    setSize(this.iframe);
    this._initEvents();
  };

  TalendoIFrame.prototype._initEvents = function _initEvents() {
    window.addEventListener('message', ({ origin, data }) => {
      // TODO: add host from .env file
      // if (!origin.includes('localhost')) return;
      if (data.type === 'autofit') setSize(this.iframe, { height: `${data.contentHeight}px` });
    }, false);
  };

  TalendoIFrame.prototype.changeColorMode = function changeColorMode(mode) {
    this.iframe.contentWindow.postMessage({ type: 'colorMode', mode }, '*');
  };

  window.TalendoIFrame = TalendoIFrame;
})();
